export default defineNuxtRouteMiddleware((to) => {
  const routePath = to.path
    .replace(/^\/(?!de)(en|fr)(?=\/|$)/, "/")
    .replace(/^\/+/, "/");

  if (routePath === "/" && !to.path.endsWith("/")) {
    return navigateTo(to.path + "/", { redirectCode: 301 });
  }
});
